import type { CardFillAdminStats } from '@/api/admin';
import type { ICardFillWorkerHealth } from '@/entities/card-fill-admin.entity';
import { cn } from '@/lib/utils';

function StatCard({ label, value, className }: { label: string; value: number | string; className?: string }) {
	return (
		<div className={cn('rounded-xl border border-border bg-card p-3', className)}>
			<p className='text-xs text-muted-foreground'>{label}</p>
			<p className='text-lg font-semibold mt-1'>{value}</p>
		</div>
	);
}

export default function CardFillStatsBar({
	enabled,
	stats,
	workerHealth,
}: {
	enabled: boolean;
	stats: CardFillAdminStats;
	workerHealth: ICardFillWorkerHealth;
}) {
	const workerLabel = !workerHealth.reachable
		? 'Недоступен'
		: workerHealth.ok
			? 'OK'
			: 'Ошибка';

	return (
		<div className='space-y-3'>
			<div className='flex flex-wrap items-center gap-2 text-sm'>
				<span
					className={cn(
						'rounded-full px-2.5 py-0.5 text-xs font-medium',
						enabled ? 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400' : 'bg-muted text-muted-foreground',
					)}
				>
					{enabled ? 'Модуль включён' : 'Модуль выключен'}
				</span>
				<span
					className={cn(
						'rounded-full px-2.5 py-0.5 text-xs font-medium',
						workerHealth.ok
							? 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400'
							: 'bg-amber-500/15 text-amber-700 dark:text-amber-400',
					)}
				>
					Worker: {workerLabel}
					{workerHealth.service ? ` · ${workerHealth.service}` : ''}
				</span>
			</div>
			<div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2'>
				<StatCard label='В очереди' value={stats.jobs.pending ?? 0} />
				<StatCard label='В работе' value={stats.jobs.running ?? 0} />
				<StatCard label='Ошибки' value={stats.jobs.failed ?? 0} />
				<StatCard label='Прокси всего' value={stats.proxies.total} />
				<StatCard label='Прокси свободно' value={stats.proxies.available} />
				<StatCard label='Прокси занято' value={stats.proxies.assigned} />
			</div>
		</div>
	);
}
